import React, { Component } from "react"
// eslint-disable-line no-unused-vars

import "./_seo-block.scss"

class SEOBlock extends Component {
  static defaultProps = {
    modifier: "",
    imageSrc: "",
    imageAltText: "",
    readMoreLabel: "",
    headline: "",
    bodyText: "",
    remainingBodyText: "",
  }

  constructor(props) {
    super(props)
    this.state = { showExtraContent: false, extraContentAnimating: false, extraContentShown: false }
  }

  expandHandler = () => {
    this.setState({ showExtraContent: true })
    setTimeout(() => {
      this.setState({ extraContentAnimating: true })
      setTimeout(() => {
        this.setState({ extraContentShown: true })
      }, 300)
    }, 50)
  }

  render() {
    return (
      <div className={`seo-block ${this.props.modifier} ${this.state.extraContentAnimating ? "is-active" : ""}`}>
        <div className="seo-block__content">
          <h3 className="seo-block__headline" data-epi-property-name="Headline">
            {this.props.headline}
          </h3>
          <p className="seo-block__body" data-epi-property-name="BodyText">
            {this.props.bodyText}
          </p>
          <p
            data-epi-property-name="RemainingBodyText"
            className={`seo-block__body2 ${this.state.showExtraContent ? "is-ready" : ""} ${this.state.extraContentAnimating ? "is-animating" : ""} ${
              this.state.extraContentShown ? "is-active" : ""
            }`}
          >
            {this.props.remainingBodyText}
          </p>
          {!this.state.showExtraContent && (
            <button className="link" onClick={this.expandHandler}>
              {this.props.readMoreLabel}
            </button>
          )}
        </div>
        <div className="seo-block__image" data-epi-property-name="Image">
          <img src={this.props.imageSrc} alt={this.props.imageAltText} />
        </div>
      </div>
    )
  }
}

export default SEOBlock
